import React from 'react';
import 'date-fns';

import css from './Search.module.css';

import {
  Redirect
} from 'react-router-dom';

import Details from './Details';
import FolderTree from '../components/FolderTree';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {
  Button,
  InputLabel,
  MenuItem,
  ListSubheader,
  FormControl,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Drawer,
  TextField,
  Checkbox,
} from '@material-ui/core';

import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Pagination from '@material-ui/lab/Pagination';


function dateToString(date) {
  return date.toISOString().substr(0, 10);
}


class Search extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      clinicCode: '',
      category: '',
      fileType: '',
      dateFrom: null,
      dateTo: null,
      description: '',
      people: '',
      folderPrefix: '',
      folderId: '',
      folderReset: () => {},
      folderHash: {},
      results: [],
      resultsPageSize: 50,
      resultsNumPages: 0,
      resultsPage: 1,
      resultsTotal: 0,
      resultsPageTokens: [],
      searchFilter: null,
      viewDetails: false,
      detailsData: {},
      selected: {},
      numSelected: 0,
      allChecked: false,
      allIndeterminate: false,
      edit: false,
      move: false,
    };
  }

  componentDidMount() {
    this.props.callback();
    this.searchFiles(this.state);
  }

  resetForm = () => {
    this.setState({
      fileName: '',
      clinicCode: '',
      category: '',
      fileType: '',
      dateFrom: null,
      dateTo: null,
      description: '',
      people: '',
      folderPrefix: '',
      folderId: '',
      selected: {},
      numSelected: 0,
      allChecked: false,
      allIndeterminate: false,
    });
    this.state.folderReset();
  }

  handleSearchChange = (key, val) => {
    this.setState({[key]: val});
  }

  handleSearchSubmit = (event) => {
    event.preventDefault();
    this.searchFiles(this.state);
  }

  getFileUrl = (path, action='read', preview=false) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = new URLSearchParams({ path: path, action: action, preview: preview });
        let endpoint = `/api/sasurl?${params}`;
        let response = await fetch(endpoint);
        let result = await response.json();
        return resolve(result.url);
      }
      catch(err) {
        return reject();
      }
    });
  }

  toggleViewDetails = (data) => async (event) => {
    if(event.target.name === 'file-checkbox' || event.target.getAttribute('data-name') === 'file-checkbox')
      return;
    
    if(data) {
      data.downloadUrl = await this.getFileUrl(data.path);
      data.folder = this.getFolderPrefix(data.path);

      // Check if is an image or video
      let fileType = data.path.split('.').pop().toLowerCase();
      
      if(['jpeg', 'jpg', 'png', 'gif', 'svg', ''].includes(fileType)) {
        data.imageUrl = data.downloadUrl;
      } else if(['mxf', 'mp4', 'mpeg4', 'mov', 'm4v'].includes(fileType)) {
        let pathParts = data.path.split('/');
        let filenameParts = pathParts.pop().split('.');
        let thumbnailPath = `${pathParts.join('/')}/thumbnail-${filenameParts[0]}.png`;
        let previewPath = `${pathParts.join('/')}/preview-${filenameParts[0]}.mp4`;
        data.imageUrl = await this.getFileUrl(thumbnailPath, 'read', true);
        data.previewUrl = await this.getFileUrl(previewPath, 'read', true);
      }
      
      this.setState({detailsData: data, viewDetails: true});
    } else 
      this.setState({detailsData: {}, viewDetails: false});
  }

  detailsCallback = () => {
    this.setState({viewDetails: false});
  }

  deleteFile = async (path) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = new URLSearchParams({ path: path });
        let endpoint = `/api/item?${params}`;
        let response = await fetch(endpoint, {
          method: 'DELETE',
        });
        let results = await response.json();
        return resolve(results);
      } catch(err) {
        reject();
      }
    });
  }

  handleFileDelete = async (path) => {
    this.setState({viewDetails: false});
    this.props.alert('Deleting File', 'Please wait...', false);
    console.log(`Deleting file: ${path}`);
    await this.deleteFile(path);
    this.props.alert('File Deleted', 'File has been successfully deleted');
    this.searchFiles(this.state);
  }

  getSearchResults = (params) => {
    return new Promise(async (resolve, reject) => {
      try {
        let endpoint = `/api/search`;
        let response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        });
        let results = await response.json();
        return resolve(results);
      }
      catch(err) {
        return reject();
      }
    });
  }

  mapResults = (ele) => {
    let pathParts = ele.path.split('/');
    return {
      id: ele.id,
      path: ele.path,
      fileName: pathParts.pop(),
      fileType: ele.payload && ele.payload.fileType,
      folder: pathParts.join('/'),
      date: ele.user_date,
      people: ele.payload && ele.payload.people,
      clinicCode: ele.payload && ele.payload.clinicCode,
      category: ele.payload && ele.payload.category,
      description: ele.payload && ele.payload.description,
      uploadedBy: ele.payload && ele.payload.uploadedBy,
    };
  }

  searchFiles = async (fields, page=1) => {
    let searchFilter = {};
    const fieldsMap = {
      clinicCode: 'clinic_code', category: 'category', fileName: 'file_name', fileType: 'file_type',
      dateFrom: 'from_date', dateTo: 'to_date', people: 'people', description: 'description'
    };

    for(const [key, value] of Object.entries(fieldsMap))
      if(fields[key] && fields[key] !== '')
        if(key === 'dateFrom' || key === 'dateTo')
          searchFilter[value] = dateToString(fields[key]);
        else
          searchFilter[value] = fields[key].trim().toLowerCase();

    // Folder Search
    if(this.state.folderPrefix && this.state.folderPrefix !== '')
      searchFilter.folder_prefix = this.state.folderPrefix;

    searchFilter.page = page;
    searchFilter.per_page = this.state.resultsPageSize;

    try {
      const searchResults = await this.getSearchResults(searchFilter);
      let results = searchResults.items;
      let totalFiles = searchResults.totalElements
      let numPages = searchResults.totalPages;
      this.setState({
        results: results.map(this.mapResults),
        resultsPage: page,
        resultsTotal: totalFiles,
        resultsNumPages: numPages,
        searchFilter: searchFilter,
      });
    } catch (err) { console.log(err) };
  }


  searchFilesPage = async (page) => {
    try {
      await this.searchFiles(this.state, page);
      this.props.alert('Loading Results', 'Progress: 100%', false);
    } catch (err) { 
      console.log(err);
      this.props.alert('Error Loading Results', 'Please try again');
    };
  }

  handleSelect = (file) => {
    const selected = this.isSelected(file.id);
    const selectedCopy = JSON.parse(JSON.stringify(this.state.selected));
    if(selected)
      delete selectedCopy[file.id];
    else
      selectedCopy[file.id] = file;
    
    let newState = { selected: selectedCopy };
    let numSelected = Object.keys(selectedCopy).length;
    let numResults = this.state.results.length;
    newState.numSelected = numSelected;
    newState.allChecked = numSelected > 0;
    newState.allIndeterminate = numSelected !== numResults && numSelected !== 0;
    this.setState(newState);
  }

  isSelected = (fileId) => {
    return Boolean(this.state.selected[fileId]);
  }

  handleEdit = () => {
    if(this.state.allChecked)
      this.setState({ edit: true });
  }

  handleMove = () => {
    if(this.state.allChecked)
      this.setState({ move: true });
  }

  handleBulkDelete = () => {
    if(!this.state.allChecked)
      return;
    
    this.props.alert(
      'Delete Confirmation',
      `Do you want to delete the ${Object.keys(this.state.selected).length} selected file(s)?`,
      false,
      this.handleBulkDeleteConfirm
    );
  }

  handleBulkDeleteConfirm = async (result) => {
    if(!result)
      return this.props.alert('Delete Canceled');

    let files = Object.values(this.state.selected);
    let noti = {
      id: `delete-files-${(new Date()).toISOString()}`,
      title: 'Deleting Files',
      message: `0/${files.length} deleted`,
      status: 'waiting',
      progress: 0,
    };

    await this.props.notiActions.add(noti);
    this.setState({ selected: {}, numSelected: 0, allChecked: false,  allIndeterminate: false });
    this.props.alert(`Deleting ${files.length} File(s)`, 'Please check the notification area for progress');

    // NoOp for now
    // let count = 0;
    // for(let i = 0; i < files.length; ++i) {
    //   let file = files[i];
    //   try {
    //     await API.graphql(graphqlOperation(deleteFile, {input: {id: file.id}}));
    //     await Storage.remove(file.s3Key);
    //     count++;
    //     let progress = 100.0 * (i + 1) / files.length;
    //     await this.props.notiActions.update({
    //       id: noti.id,
    //       message: `${count}/${files.length} deleted`,
    //       progress: progress,
    //     });
    //     setTimeout(() => this.searchFiles(this.state, 'and'), 1000);
    //   } catch(err) {
    //     console.log(err);
    //     this.props.notiActions.add({
    //       id: `delete-files-${(new Date()).toISOString()}`,
    //       title: 'Error Deleting File',
    //       message: `File "${file.fileName}" could not be deleted.`,
    //       status: 'done',
    //     });
    //   }
    // }

    this.props.notiActions.update({
      id: noti.id,
      title: 'Delete Complete',
      status: 'done',
    });
  }

  selectAll = () => {
    if(this.state.allChecked)
      this.setState({ selected: {}, numSelected: 0, allChecked: false,  allIndeterminate: false });
    else {
      let selected = {};
      for(let file of this.state.results)
        selected[file.id] = file;
      this.setState({ selected: selected, numSelected: this.state.results.length, allChecked: true,  allIndeterminate: false });
    }
  }

  folderOnSelect = (folderPrefix, folderId) => {
    this.setState({ folderPrefix: folderPrefix, folderId: folderId });
  }

  folderOnInit = ({ reset, hash }) => {
    this.setState({ folderReset: reset, folderHash: hash });
  }

  getFolderPrefix = (path) => {
    let pathParts = path.split('/').slice(0, -1);
    return pathParts.length === 0 ? 'root/' : pathParts.join('/');
  }

  handlePagination = async (event, value) => {
    try {
      this.props.alert('Loading Results', 'Progress: 0%', false);
      await this.searchFilesPage(value);
      this.props.alert();
    } catch(err) {
      console.log(err);
      this.props.alert('Error Loading Results', 'Please try again');
    }
    
  }

  render() {
    return (
      <React.Fragment>
        <Container fluid={true}>
          <Row>
            <Col sm={2}>
              <form onSubmit={this.handleSearchSubmit} noValidate>
                <FormControl className="w-100 m-1">
                  <TextField 
                    labelId="people-input-label" 
                    id="filename" 
                    label="File Name" 
                    value={this.state.fileName}
                    onChange={(event) => this.handleSearchChange('fileName', event.target.value)}
                  />
                </FormControl>

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="from-date"
                    className="w-100 m-1"
                    label="From Date"
                    value={this.state.dateFrom}
                    onChange={(date) => this.handleSearchChange('dateFrom', date)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="to-date"
                    className="w-100 m-1"
                    label="To Date"
                    value={this.state.dateTo}
                    onChange={(date) => this.handleSearchChange('dateTo', date)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </MuiPickersUtilsProvider>

                <FormControl className="w-100 m-1">
                  <TextField 
                    labelId="people-input-label" 
                    id="people" 
                    label="People" 
                    value={this.state.people}
                    onChange={(event) => this.handleSearchChange('people', event.target.value)}
                  />
                </FormControl>
                
                <FormControl className="w-100 m-1">
                  <InputLabel id="clinic-code-select-label">Clinic Code</InputLabel>
                  <Select
                    labelId="clinic-code-select-label"
                    id="clinic-code-select"
                    value={this.state.clinicCode}
                    onChange={(event) => this.handleSearchChange('clinicCode', event.target.value)}
                  >
                    <MenuItem value=""></MenuItem>
                    <MenuItem value="">All</MenuItem>
                    {this.props.clinicCodes.map((item, index) => (
                      item.disabled ?
                      <ListSubheader key={index} disableSticky={true} value="">{item.display}</ListSubheader> :
                      <MenuItem key={index} value={item.value}>{`${item.value} - ${item.display}`}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl className="w-100 m-1">
                  <InputLabel id="category-select-label">Categories</InputLabel>
                  <Select
                    labelId="category-select-label"
                    id="category-select"
                    value={this.state.category}
                    onChange={(event) => this.handleSearchChange('category', event.target.value)}
                  >
                    <MenuItem value=""></MenuItem>
                    <MenuItem value="">Any</MenuItem>
                    {this.props.categories.map((item, index) => (
                      <MenuItem key={index} value={item.value}>{item.display}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                <FormControl className="w-100 m-1">
                  <TextField 
                    labelId="file=type-input-label" 
                    id="file-type" 
                    label="File Type" 
                    value={this.state.fileType}
                    onChange={(event) => this.handleSearchChange('fileType', event.target.value)}
                  />
                </FormControl>

                <FormControl className="w-100 m-1">
                  <TextField 
                    labelId="description-input-label" 
                    id="standard-basic" 
                    label="Description" 
                    value={this.state.description}
                    onChange={(event) => this.handleSearchChange('description', event.target.value)}
                  />
                </FormControl>
                <br /><br />
                <FormControl className="w-100 m-1">
                  Folders:
                  <FolderTree onInit={this.folderOnInit} onSelect={this.folderOnSelect} />
              </FormControl>
              <br /><br />
                <div>
                  <Button className="float-left" onClick={this.resetForm}>Clear</Button>
                  <Button className="float-right" type="submit">Search</Button>
                </div>
              </form>
            </Col>
            <Col sm={10}>
              <Button onClick={this.handleEdit}>Edit Selected</Button>
              { this.state.edit ? <Redirect to={{ pathname: '/edit', state: { files: this.state.selected } }} /> : null }
              <Button onClick={this.handleMove}>Move Selected</Button>
              { this.state.move ? <Redirect to={{ pathname: '/move', state: { files: this.state.selected } }} /> : null }
              <Button onClick={this.handleBulkDelete}>Delete Selected</Button>
              <div>
                <div className='ml-2'>{this.state.resultsTotal} Files</div>
                <Pagination page={this.state.resultsPage} count={this.state.resultsNumPages} onChange={this.handlePagination} showFirstButton showLastButton />
              </div>
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        Select
                        <br />
                        { this.state.numSelected !== 0 ? `(${this.state.numSelected})` : null }
                        <Checkbox 
                          checked={this.state.allChecked} onChange={this.selectAll} name="allchecked"
                          color="primary" indeterminate={this.state.allIndeterminate}
                        />
                      </TableCell>
                      <TableCell>File Name</TableCell>
                      <TableCell>Folder</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>People</TableCell>
                      <TableCell>Clinic Codes</TableCell>
                      <TableCell>Categories</TableCell>
                      <TableCell>Uploaded By</TableCell>
                      <TableCell>View</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.results.map((row, index) => (
                      <TableRow key={index} className={css.file} onClick={this.toggleViewDetails(row)}>
                        <TableCell data-name="file-checkbox">
                          <Checkbox checked={this.isSelected(row.id)} onChange={() => this.handleSelect(row)} name="file-checkbox" color="primary" />
                        </TableCell>
                        <TableCell component="th" scope="row">{row.fileName}</TableCell>
                        <TableCell>root/{row.folder}</TableCell>
                        <TableCell>{row.date}</TableCell>
                        <TableCell>{row.people}</TableCell>
                        <TableCell>{row.clinicCode}</TableCell>
                        <TableCell>{row.category}</TableCell>
                        <TableCell>{row.uploadedBy}</TableCell>
                        <TableCell><Button>View</Button></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Col>
          </Row>
        </Container>
        <Drawer anchor={'right'} open={this.state.viewDetails} onClose={this.toggleViewDetails()}>
          <Details data={this.state.detailsData} callback={this.detailsCallback} onDelete={this.handleFileDelete} />
        </Drawer>
      </React.Fragment>
    );
  }
}

Search.defaultProps = {
  clinicCodes: [
    // CLINIC
    {value: 'Clinics', display: 'Clinics', disabled: true},
    {value: 'ASC', display: 'Ambulatory Surgery Center', disabled: false},
    {value: 'PAIN', display: 'Back and Neck Pain Center', disabled: false},
    {value: 'CMC', display: 'Comprehensive Memory Center', disabled: false},
    {value: 'DERM', display: 'Dermatology', disabled: false},
    {value: 'ENDO', display: 'Endocrinology', disabled: false},
    {value: 'INF', display: 'Infectious Disease', disabled: false},
    {value: 'LCI', display: 'Livestrong Cancer Institutes', disabled: false},
    {value: 'EYE', display: 'Mitchel and Shannon Wong Eye Institute', disabled: false},
    {value: 'MS', display: 'Multiple Sclerosis and Neuroimmunology Center', disabled: false},
    {value: 'MULV', display: 'Mulva Clinic for the Neurosciences', disabled: false},
    {value: 'MSK', display: 'Musculoskeletal Institute', disabled: false},
    {value: 'PRIM', display: 'Primary Care', disabled: false},
    {value: 'RHEUM', display: 'Rheumatology', disabled: false},
    {value: 'SURGONC', display: 'Surgical Oncology', disabled: false},
    {value: 'WI', display: 'Walk In', disabled: false},
    // ADULT PARTNER PROGRAMS
    {value: 'Adult Partner Programs', display: 'Adult Partner Programs', disabled: true},
    {value: 'DM', display: 'Digestive Health', disabled: false},
    {value: 'TC', display: 'Transplant Center', disabled: false},
    {value: 'WH', display:"Women’s Health", disabled: false},
    // PEDIATRIC PARTNER PROGRAMS
    {value: 'Pediatric Partner Programs', display: 'Pediatric Partner Programs', disabled: true},
    {value: 'CFCC', display: 'Comprehensive Fetal Care Center', disabled: false},
    {value: 'TCPCHD', display: 'Texas Center for Pediatric and Congenital Heart Disease', disabled: false},
    {value: 'PEDIPRIM', display: 'Primary Pediatrics at Mueller', disabled: false},
    {value: 'PEDINEURO', display: "UT Health Austin Pediatric Neurosciences at Dell Children's", disabled: false},
    {value: 'PEDIPSYCH', display: "UT Health Austin Pediatric Psychiatry at Dell Children’s", disabled: false},
    // ORGANIZATION
    {value: 'Organizations', display: 'Organizations', disabled: true},
    {value: 'UTHA', display: 'UT Health Austin', disabled: false},
    {value: 'DCMC', display: "Dell Children’s Medical Center", disabled: false},
    {value: 'DMS', display: 'Dell Medical School', disabled: false},
    {value: 'ASCSTN', display: 'Ascension Seton', disabled: false},
  ],
  categories: [
    {value: 'patientStory', display: 'Patient Story'},
    {value: 'askFriend', display: 'Asking for a Friend'},
    {value: 'providerBio', display: 'Provider Bio Video'},
    {value: 'healthCuriosity', display: 'Healthy Curiosity'},
    {value: 'interview', display: 'Interview'},
    {value: 'surgeryProcedure', display: 'Surgery/Procedure'},
    {value: 'event', display: 'Event'},
  ],
  fileTypes: [
    {value: 'mxf', display: '.MXF'},
    {value: 'mp4', display: '.MP4'},
    {value: 'mov', display: '.MOV'},
    {value: 'mp3', display: '.MP3'},
    {value: 'wav', display: 'WAV'},
  ],
};

export default Search;